/**
 * Утилиты для работы с Rate Limiting
 */

/**
 * Форматирует сообщение об ошибке rate limit для пользователя
 * @param {Object} rateLimitData - Данные об ошибке rate limit
 * @returns {string} - Форматированное сообщение
 */
export function formatRateLimitMessage(rateLimitData) {
    let message = 'Слишком много запросов. ';
    
    if (rateLimitData?.retry_after) {
        const retryAfter = rateLimitData.retry_after;
        if (retryAfter >= 60) {
            const minutes = Math.ceil(retryAfter / 60);
            message += `Попробуйте снова через ${minutes} ${getMinutesText(minutes)}.`;
        } else {
            message += `Попробуйте снова через ${retryAfter} ${getSecondsText(retryAfter)}.`;
        }
    } else {
        message += 'Попробуйте снова позже.';
    }
    
    // Добавляем информацию о лимитах, если доступна
    if (rateLimitData?.limit && rateLimitData?.window) {
        message += ` (Лимит: ${rateLimitData.limit} запросов за ${getMinutesText(rateLimitData.retry_after)})`;
    }
    
    return message;
}

/**
 * Возвращает правильную форму слова "минута" для числа
 * @param {number} minutes - Количество минут
 * @returns {string} - Правильная форма слова
 */
function getMinutesText(minutes) {
    if (minutes === 1) return 'минуту';
    if (minutes >= 2 && minutes <= 4) return 'минуты';
    return 'минут';
}

/**
 * Возвращает правильную форму слова "секунда" для числа
 * @param {number} seconds - Количество секунд
 * @returns {string} - Правильная форма слова
 */
function getSecondsText(seconds) {
    if (seconds === 1) return 'секунду';
    if (seconds >= 2 && seconds <= 4) return 'секунды';
    return 'секунд';
}

/**
 * Проверяет, является ли ошибка rate limit ошибкой
 * @param {Object} error - Объект ошибки
 * @returns {boolean} - true если это rate limit ошибка
 */
export function isRateLimitError(error) {
    return error?.response?.status === 429;
}